import React, { useState } from 'react';
import './FAQSection.css';

const faqs = [
  {
    question: 'Why should you train your breath?',
    answer: 'How you breathe is trainable, and it affects more than you would expect. Raising your CO2 tolerance improves how efficiently your body uses oxygen, which most research links to steadier breathing under effort, faster recovery after hard efforts, and a nervous system you can downshift on demand. Ayro trains those adaptations directly instead of leaving them to chance.',
  },
  {
    question: 'How is Ayro different from other breathing apps?',
    answer: 'Most breathing apps hand you a library of exercises and a timer. Ayro builds you a plan. It starts from your BOLT score, your goals, and your schedule, then programs recovery and endurance training that adapts as your numbers improve. No other breathing app is built around a measurable baseline you can actually move.',
  },
  {
    question: 'What is the BOLT score?',
    answer: 'The BOLT score (Body Oxygen Level Test) is a breath-hold test that measures your CO2 tolerance and breathing efficiency. Ayro uses it to place you at the right training level from day one and track progress over time.',
  },
  {
    question: 'How long are the sessions?',
    answer: 'Quick Tools run 2 to 5 minutes and are built for specific moments: pre-workout activation, mid-day focus, post-training recovery. Training sessions run longer (5 to 10 minutes) and build the underlying adaptations that move your metrics. Both are designed to slot into a real schedule without carving out dedicated time.',
  },
  {
    question: 'Will this actually improve my performance?',
    answer: 'Every session in Ayro is built on established breathwork science, targeting measurable adaptations: HRV, CO2 tolerance, resting heart rate, recovery speed, and focus under pressure. The app tracks your BOLT score over time, along with resting heart rate and HRV from your wearable, so progress is a number, not a feeling.',
  },
  {
    question: 'Where and when should I use Ayro?',
    answer: 'Anywhere. At your desk, on a walk, in the gym, or in bed. Ayro works with haptic cues, audio guidance, and picture-in-picture so you can run a session wherever you are. It fits around your existing training schedule rather than adding to it.',
  },
  {
    question: "What's included in the free trial?",
    answer: "Everything. Your BOLT test, personalized training block, full session library, Quick Tools, cue modes, and progress tracking. Free for 7 days, no commitment until you've seen what it can do.",
  },
];

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq-section">
      <div className="faq-section__inner">
        <h2>FAQs.</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div className="faq-item" key={faq.question}>
                <button className="faq-item__button" onClick={() => setOpenIndex(isOpen ? null : index)}>
                  <span>{faq.question}</span>
                  <span className={`faq-item__icon${isOpen ? ' is-open' : ''}`} aria-hidden="true">+</span>
                </button>
                <div className={`faq-item__answer${isOpen ? ' is-open' : ''}`}>
                  <div>{faq.answer}</div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="faq-section__contact">
          Have more questions? Email us at <a href="mailto:support@ayro.fit">support@ayro.fit</a>
        </p>
      </div>
    </section>
  );
}

export default FAQSection;
